<template>
  <div>
    <flex-align
      v-if="
        isGridBuilder &&
        selected.parent().name === 'GridItemWrapper' &&
        !hideFlexAlignment
      "
      :mode="mode"
      :disable-alignment="hideFlexAlignment"
      :disable-constrain="hideFlexAlignment"
    ></flex-align>
    <cvt-collapse
      :accordion="true"
      :theme="mode === 'LIGHT' ? 'light' : 'dark'"
      :prepend-chevron="prependChevron"
    >
      <cvt-collapse-item
        v-if="containerItemSettings.isWrappedByCContainerItem"
        title="Container Item Options"
        :special-style="isSpecialStyle"
      >
        <c-container-item-options :mode="mode" />
      </cvt-collapse-item>
      <div class="divider mt-2" />
      <cvt-collapse-item
        title="Image"
        name="image"
        :initial-active="true"
        :special-style="isSpecialStyle"
      >
        <element-image-manager
          image-key="src"
          :hook="selected.updateSrc"
        ></element-image-manager>
        <div v-if="!isGridBuilder" class="row">
          <h6 class="col text-capitalize">
            {{ $t('element  .property.label.resize') }}
          </h6>

          <div class="col-12">
            <resize hide-label></resize>
          </div>
        </div>

        <div
          v-if="isGridBuilder"
          class="row mt-4 d-flex justify-content-between"
        >
          <div class="col">
            <h6>{{ $t('element.property.label.crop_logo') }}</h6>
          </div>
          <div class="col-3">
            <cvt-switch
              size="sm"
              color="active"
              type="circular"
              description-type="default"
              :initial-state="hideLogoOverflow"
              :mode="mode"
              @switchToggle="(status) => updateLogoCrop(status)"
            ></cvt-switch>
          </div>
        </div>

        <div v-if="OrgName !== orgNameFreshWork" class="divider" />
        <div v-else class="mt-3" />

        <div class="row">
          <h6 class="col text-capitalize">
            {{ $t('element.property.image.alt.label') }}
          </h6>
          <div class="col-12">
            <cvt-input
              v-model="alt"
              type="text"
              :placeholder="$t('element.property.image.alt.alt_message')"
            ></cvt-input>
          </div>
        </div>

        <div v-if="OrgName !== orgNameFreshWork" class="divider" />
        <div v-else class="mt-3" />

        <div class="row">
          <h6 class="col text-capitalize">
            {{ $t('element.property.link') }}
          </h6>
          <div class="col-12">
            <url-input
              v-model="href"
              type="text"
              :placeholder="$t('element.property.image.alt.link_message')"
            ></url-input>
          </div>
        </div>
      </cvt-collapse-item>

      <cvt-collapse-item
        v-if="!isGridBuilder"
        :title="$t('elements.properties.alignment')"
        name="alignment"
        :special-style="isSpecialStyle"
      >
        <flex-align :mode="mode"></flex-align>
      </cvt-collapse-item>

      <cvt-collapse-item
        :title="$t('elements.properties.spacing.label')"
        name="spacing"
        :special-style="isSpecialStyle"
      >
        <spacing-ctrl></spacing-ctrl>
      </cvt-collapse-item>
      <cvt-collapse-item
        v-if="isGridBuilder"
        title="Style"
        name="style"
        :special-style="isSpecialStyle"
      >
        <!-- <div class="row">
          <div class="col-md-12 mb-3 d-flex align-items-center text-capitalize">
            {{ $t("elements.properties.background.color") }}
          </div>
          <div class="col-12">
            <colors alpha :mode="mode"/>
          </div>
        </div>

        <div class="divider mt-2" /> -->

        <div
          v-if="['GridItemWrapper', 'CContainerItem'].includes(selected.parent().name)"
        >
          <border-style-options
            :mode="mode"
            :border-style="selected.parent().borderStyle || 'none'"
            :border-color="selected.parent().borderColor || null"
            :border-width="selected.parent().borderWidth || 0"
            :border-radius="selected.parent().borderRadius || 0"
            :update-prop-function="selected.parent().updateProp"
          />
        </div>
      </cvt-collapse-item>
    </cvt-collapse>
  </div>
</template>

<script>
import * as _ from 'lodash'
import Resize from './Resize.vue'
import SpacingCtrl from './SpacingCtrl.vue'
import FlexAlign from './FlexAlign.vue'
// import Colors from '../theme/Colors.vue'
import ElementImageManager from './ElementImageManager.vue'
import { mapGetters, mapActions, mapState } from 'vuex'
import * as getters from '../../../store/modules/getters'
import * as actions from '../../../store/modules/actions'
import {
  LEFT_SIDEBAR_FRESHWORKS,
  LEFT_SIDEBAR_STANDARD,
} from '../../../../../../storybook/components/constants'
import CContainerItemOptions, {
  useShowContainerItem,
} from './CContainerOptions/CContainerItemOptions.vue'
import BorderStyleOptions from './BorderStyleOptions.vue'
export default {
  components: {
    Resize,
    SpacingCtrl,
    FlexAlign,
    ElementImageManager,
    CContainerItemOptions,
    // Colors
    BorderStyleOptions,
  },
  props: {
    mode: {
      type: String,
      default: 'LIGHT',
    },
    prependChevron: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeTabs: ['image'],
      orgNameFreshWork: LEFT_SIDEBAR_FRESHWORKS,
      borderStyles: [
        'none',
        'solid',
        // 'ridge',
        // 'inset',
        // 'outset',
        'dashed',
        'dotted',
        'double',
        'groove',
      ],
      borderWidth: 0,
      borderRadius: 0,
    }
  },
  computed: {
    ...mapGetters({
      selected: getters.SELECTOR_SELECTED,
      config: getters.AUTH_GET_USER_CONFIG,
      isGridBuilder: getters.IS_GRID_BUILDER,
    }),
    ...mapState('globalTheme', {
      OrgName: ({ globalTheme }) =>
        globalTheme.OrgName !== undefined
          ? globalTheme.OrgName
          : LEFT_SIDEBAR_STANDARD,
    }),
    alt: {
      get() {
        return this.selected.alt
      },

      set: _.debounce(function ({ target }) {
        return this.updateProp({
          key: 'alt',
          value: target.value,
        })
      }, 800),
    },
    href: {
      get() {
        return this.selected.href || ''
      },
      set: _.debounce(function (value) {
        this.updateProp({
          key: 'href',
          value: value,
        })
        return value
      }, 800),
    },
    isSpecialStyle() {
      return this.OrgName === LEFT_SIDEBAR_FRESHWORKS
    },
    hideLogoOverflow: {
      get() {
        return this.selected.hideLogoOverflow
      },
      set(value) {
        return this.updateProp({ key: 'hideLogoOverflow', value })
      },
    },
    hideFlexAlignment() {
      return this.config.HIDE_FLEX_ALIGNMENT_OPTIONS?.logo === true
    },
    containerItemSettings() {
      return useShowContainerItem(this.selected)
    },
  },
  methods: {
    ...mapActions({
      updateProp: actions.SELECTOR_UPDATE_PROP,
    }),
    updateLogoCrop(status) {
      if (status === 'Active') {
        this.hideLogoOverflow = true
      } else if (status === 'Inactive') {
        this.hideLogoOverflow = false
      }
    },
  },
}
</script>
